export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5661.8fc8ec1e.jpg";